import { render, staticRenderFns } from "./ChamadoCard.vue?vue&type=template&id=5ba04a40&scoped=true&"
import script from "./ChamadoCard.vue?vue&type=script&lang=js&"
export * from "./ChamadoCard.vue?vue&type=script&lang=js&"
import style0 from "./ChamadoCard.vue?vue&type=style&index=0&id=5ba04a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba04a40",
  null
  
)

export default component.exports